(async () => {
  const el = document.getElementById('doctor-list-content')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/vrach/index.vue'),
    },
  ]

  await clientRender({ components })
})()
